import { render, staticRenderFns } from "./MerchantStatement.vue?vue&type=template&id=6f836f59&scoped=true"
import script from "./MerchantStatement.vue?vue&type=script&lang=js"
export * from "./MerchantStatement.vue?vue&type=script&lang=js"
import style0 from "./MerchantStatement.vue?vue&type=style&index=0&id=6f836f59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f836f59",
  null
  
)

export default component.exports